import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import { fetchCsrfCookie } from '../../../../../redux/action/csrf/csrf-cookie';
import MainLoading from '../../../../../utils/MainLoading';

const EditModal = (props) => {
    const [btnLoading, setBtnLoading] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0)
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState({
        title: '',
        url: ''
    })
    const dispatch = useDispatch()
    const {t} = useTranslation();

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است"
        },
    }))

    useEffect(() => {
        setLoading(true)
        axios.get(`p/link/${props.id}`)
        .then(response => {
            setLoading(false)
            setData({
                title: response.data.title ? response.data.title : '',
                url : response.data.url ? response.data.url : ''
            })
        })
        .catch(err => console.log(err))
    }, [props.id])

    const submitEditLink = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            dispatch(fetchCsrfCookie())
            axios.put(`admin/link/${props.id}`, data)
            .then(res => {
                setBtnLoading(false)
                toast.dismiss()	
                toast.success(t("toast_successfully_edited") , {position: 'bottom-right',className: 'foo-bar'})
                props.update()
            })
            .catch(err => {
                console.log(err)
                setBtnLoading(false)
                toast.dismiss()
                toast.error(t("toast_something_went_wrong") , {position: 'bottom-right',className: 'foo-bar'})
            })
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }
    }

    const handleDataChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    return (
        <>
            {props.show && (
                <Modal show={props.show}>
                    <Modal.Header>
                        <Modal.Title> {t("edit")} </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {loading ?
                            <MainLoading /> 
                        :
                            <Form onSubmit={e => submitEditLink(e)}>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>{t("title")} :</Form.Label>
                                    <Form.Control type="text" name="title" value={data.title} onChange={handleDataChange} />
                                    <span className='validator_error'>{validator.current.message('title', data.title, 'required')}</span>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>{t("url")} :</Form.Label>
                                    <Form.Control type="text" name="url" value={data.url} onChange={handleDataChange} />
                                    <span className='validator_error'>{validator.current.message('url', data.url, 'required')}</span>
                                </Form.Group>
                                <button className='btn green-btn col-md-3' type="submit" disabled={btnLoading ? true : false}>
                                    {t("submit")}
                                </button>
                            </Form>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={props.handleClick}>
                            {t("Cancel")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    )
}

export default EditModal
